import { createSlice } from "@reduxjs/toolkit";

const initialScheduleState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  scheduleForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const scheduleSlice = createSlice({
  name: "schedule",
  initialState: initialScheduleState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    scheduleFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    scheduleAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    scheduleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.schedule.push(action.payload.schedule);
    },
    scheduleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.schedule.filter(el => el.schedule_id !== action.payload.id);
    },
    getSchedule: (state, action) => {
      state.actionsLoading = false;
      state.scheduleForEdit = action.payload.scheduleForEdit;
      state.error = null;
    },
    // updateProduct
    scheduleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.schedule = state.entities.schedule.map(entity => {
        if (entity.schedule_id === action.payload.schedule.schedule_id) {
          return action.payload.schedule;
        }
        return entity;
      });
    },
  },
});
